import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=c73a03dc&scoped=true"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductManagement.vue?vue&type=style&index=0&id=c73a03dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73a03dc",
  null
  
)

export default component.exports